import { createContext, Dispatch, SetStateAction } from "react";
import { TabsItemFiles } from "../utils/enums/tabs";
import { FilterBody } from "../../../hooks/filter/typing";
import { Item } from "../../../utils/types/generals";
import { InputModel } from "../../../utils/types";
import { DownloadType } from "../../../hooks/download/useDownload";

export interface FilesManagerContextType {
  tabValue: TabsItemFiles;
  setTabValue: Dispatch<SetStateAction<TabsItemFiles>>;
  selectedIds: number[];
  setSelectedIds: Dispatch<SetStateAction<number[]>>;
  notFileSelected: number[];
  setNotFileSelected: Dispatch<SetStateAction<number[]>>;
  isChecked: boolean;
  setIsChecked: Dispatch<SetStateAction<boolean>>;
  filterFileMain: FilterBody;
  filterMainData: {
    items: {
      [x: string]: Item[];
    };
    input: {
      [x: string]: InputModel;
    };
    getData: () => Promise<void>;
  }
  filterFileList: FilterBody;
  filterListData: {
    items: {
      [x: string]: Item[];
    };
    input: {
      [x: string]: InputModel;
    };
    getData: () => Promise<void>;
  };
  isLoading: boolean
  uuid: string
  typeDownload: string | undefined
  getDetailInform: ({ query, type }: {
    query?: string;
    type?: DownloadType
  }) => Promise<void>
}

export const FilesManagerContext = createContext<FilesManagerContextType>(
  {} as FilesManagerContextType
);